<i18n>
{
  "en": {
    "tabs":{
      "automatic": "Automatic",
      "manual": "Manual"
    },
    "buttons" :{
      "add": "Create automatic report",
      "create": "Create report and send",
      "delete": "Delete",
      "ok": "OK"
    },
    "form": {
      "fields": {
        "type": "Report type",
        "distributor": "Distributor",
        "serialnumber": "System S/N",
        "from": "From",
        "to": "To"
      },
      "title": {
        "add": "Add automatic payment report",
        "delete": "Delete automatic payment report?"
      },
      "texts": {
        "delete": "This will delete the automatic payment report. This action cannot be undone!"
      },
      "options": {
        "types": {
          "select": "Select automatic payment report type",
          "oncreate": "Send report when new credit file is created",
          "monthly": "Send report monthly"
        }
      }
    },
    "confirm": {
      "title": "Payment report has been requested",
      "content": "A new payment report has been requested and will be sent to {email}."
    },
    "table": {
      "headers": {
        "type": "Report type",
        "distributor": "Distributor",
        "serial": "System S/N",
        "actions": "Actions"
      },
      "types": {
        "create": "Send report when new credit file is created",
        "monthly": "Send report monthly"
      },
      "all": "All"
    }
  },
  "da": {
    "tabs":{
      "automatic": "Automatisk",
      "manual": "Manuelt"
    },
    "buttons" :{
      "add": "Tilføj automatisk rapport", 
      "create": "Opret rapport og send",
      "delete": "Slet",
      "ok": "OK"
    },
    "form": {
      "fields": {
        "type": "Rapport type",
        "distributor": "Distributør",
        "serialnumber": "System serienummer",
        "from": "Fra",
        "to": "Til"
      },
      "title": {
        "add": "Tilføj automatisk betalingsrapport",
        "delete": "Slet automatisk betalingsrapport?"
      },
      "texts": {
        "delete": "Dette vil slette den automatiske betalingsrapport. Denne handling kan ikke fortrydes!"
      },
      "options": {
        "types": {
          "select": "Vælg automatisk betalingsrapport type",
          "oncreate": "Send rapport når en ny kredit fil bliver oprettet",
          "monthly": "Send månedlig rapport"
        }
      }
    },
    "confirm": {
      "title": "Betalingsrapport anmodet",
      "content": "En ny betalingsrapport er blevet anmodet, og vil blive send til {email}."
    },
    "table": {
      "headers": {
        "type": "Rapport type",
        "distributor": "Distributør",
        "serial": "System serienummer",
        "actions": "Handlinger"
      },
      "types": {
        "create": "Send rapport når en ny kredit fil bliver oprettet",
        "monthly": "Send månedlig rapport"
      },
      "all": "Alle"
    }
  }
}
</i18n>

<template>
  <layout>
    <b-container>

      <b-row>
        <b-col lg="8" offset-lg="2" class="pt-1"> 
          <b-card no-body>
            <b-tabs card>
              <b-tab :title="$t('tabs.automatic')" active>

                <b-row class="my-2">
                  <b-button class="ml-3" variant="success" v-on:click="showAddReport()">
                    {{$t('buttons.add')}}
                  </b-button>
                </b-row>


                <b-table striped hover :items="automaticpaymentreports"  :fields="fields" small responsive="xl" >
                  <template v-slot:head(HEAD_AutomaticPaymentReportTypeID)="scope">
                    {{$t('table.headers.type')}}
                  </template>
                  <template v-slot:head(Distributor)="scope">
                    {{$t('table.headers.distributor')}}
                  </template>
                  <template v-slot:head(System.SerialNumber)="scope">
                    {{$t('table.headers.serial')}}
                  </template>
                  <template v-slot:head(System.Actions)="scope">
                    {{$t('table.headers.actions')}}
                  </template>
     
                  <template v-slot:cell(AutomaticPaymentReportTypeID)="data">
                    <span v-if="data.item.AutomaticPaymentReportTypeID == 10">{{$t('table.types.create')}}</span>
                    <span v-if="data.item.AutomaticPaymentReportTypeID == 20">{{$t('table.types.monthly')}}</span>
                  </template>
                  <template v-slot:cell(Distributor)="data">
                    {{ data.item.Distributor||$t('table.all') }}
                  </template>
                  <template v-slot:cell(System.SerialNumber)="data">
                    {{ (data.item.System||{}).SerialNumber||$t('table.all') }}
                  </template>
                  <template v-slot:cell(Actions)="data">
                    <b-button size="sm"  variant="danger" @click="showDeleteReport(data)">
                      {{$t('buttons.delete')}}
                    </b-button>
                  </template>
                  
                </b-table>              
              </b-tab>
              
              <b-tab :title="$t('tabs.manual')" >

                <b-form @submit.prevent="validateBeforeSubmit('paymentreport', submitNewPaymentReport)" onsubmit="return false" data-vv-scope="paymentreport">
      
                  <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.distributor')"> 
                    <b-form-select v-model="selected.distributor" :options="distributors" class="mb-3" />
                  </b-form-group>

                  <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.serialnumber')"> 
                    <b-form-select v-model="selected.system" :options="systemSelection" class="mb-3" />
                  </b-form-group>

                  <!--
                  <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('email')"> 
                    <b-form-input v-model="selected.user"></b-form-input>
                  </b-form-group>
                  -->                  

                  <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.from')"> 
                    <flat-pickr v-model="selected.from"
                      name="from"
                      class="form-control"
                      :config="dateSelectConfig"
                      @on-close=";"
                    ></flat-pickr>
                  </b-form-group>                
                  
                  <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.to')"> 
                    <flat-pickr v-model="selected.to"
                      name="to"
                      class="form-control"
                      :config="dateSelectConfig"
                      @on-close=";"
                    ></flat-pickr>
                  </b-form-group>         

                  <b-button type="submit"  class="mt-3" variant="outline-success" block >{{$t('buttons.create')}}</b-button>

                </b-form>

              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

    </b-container>

    <b-modal ref="deleteAutomaticPaymentReportConfirm" hide-footer :title="$t('form.title.delete')">
      <div class="d-block text-center">
        <h6>{{ $t('form.texts.delete', "") }}</h6>
      </div>
      <b-button class="mt-3" variant="outline-danger" block @click="deleteAutomaticPaymentReport()" >{{$t('buttons.delete')}}</b-button>
    </b-modal>

    <b-modal ref="addAutomaticPaymentReportConfirm" hide-footer :title="$t('form.title.add')">
      <b-form @submit.prevent="validateBeforeSubmit('automaticpaymentreport', submitNewAutomaticPaymentReport)" onsubmit="return false" data-vv-scope="automaticpaymentreport">

         <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.type')"> 
          <b-form-select v-model="selected.automaticpaymentreporttype" class="mb-3" name="type" v-validate="{ required: true, is_not: null }">
            <option :value="undefined" disabled>{{ $t('form.options.types.select') }}</option>
            <option :value="10">{{ $t('form.options.types.oncreate') }}</option>
            <option :value="20">{{ $t('form.options.types.monthly') }}</option>
          </b-form-select>
          <span class="error" v-show="errors.has('automaticpaymentreport.type')">{{errors.first('automaticpaymentreport.type')}}</span>
        </b-form-group>

        <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.distributor')"> 
          <b-form-select v-model="selected.distributor" :options="distributors" class="mb-3" />
        </b-form-group>

        <b-form-group horizontal :label-cols="3" label-size="sm" :label="$t('form.fields.serialnumber')"> 
          <b-form-select v-model="selected.system" :options="systemSelection" class="mb-3" />
        </b-form-group>

        <b-button type="submit"  class="mt-3" variant="outline-success" block >{{$t('buttons.add')}}</b-button>

      </b-form>

    </b-modal>

    <b-modal ref="paymentReportRequested" :title="$t('confirm.title')" cancel-disabled ok-only	>
      <p class="my-4">{{ $t('confirm.content', {email: userEmail}) }}</p>
    </b-modal>


  </layout>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { english } from 'flatpickr/dist/l10n/default.js';

import moment from 'moment';

import elg from '../api/elg.gateway.js'
import Layout from './Layout'

import jwt from '../utils/jwt.js'

export default {
  components: {
    flatPickr,
    Layout
  },
  data() {
    return {
      paymentreport: {},
      selected: {
        distributor: null,
        system: null,
        automaticpaymentreporttype: undefined,
        automaticpaymentreport: {}
      },
      distributors: [],
      systems: [],
      automaticpaymentreports: [],
      fields: [
        'AutomaticPaymentReportTypeID',
        'Distributor',
        'System.SerialNumber',
        'Actions'
      ]
    }
  },
  computed: {
    systemSelection: function() {
      var select = [
        {
          value: null,
          text: '*'
        }
      ];

      for (var i = 0; i < this.systems.length; i++) {
        var system = this.systems[i];
        if(system.SerialNumber === '') continue;
        
        if(this.selected.distributor === null || system.Distributor === this.selected.distributor){
          select.push({
            value: system.LogosID,
            text: system.SerialNumber
          });
        }
      }
      return select;
    },
    dateSelectConfig() {
      var FlatpickrLanguageMap = {
        "da": Danish,
        "en": english
      };
      return {
        locale: FlatpickrLanguageMap[this.$root.$i18n.locale],
        enableTime: true,
        time_24hr: true
      }
    },
    userEmail(){
      return jwt.getEmail()
    }
 
  },
  methods: {
    contains(obj){
      var found = false;
      for(var i = 0; i < this.systems.length; i++){
        if( this.systems[i].LogosID === obj.LogosID ){
          found = true;
          break;
        }
      }

      return found;
    },
    getDistributors(){
      elg()
      .get("/api/v1/systems/distributors")
      .then(res => {
        var data = res.data;
        this.distributors.push({
          value: null,
          text: '*'
        })
        
        for (var i = 0; i < data.length; i++) {
          var distributor = data[i];
          if(!this.contains(distributor)){
            this.distributors.push({
              value: distributor,
              text: distributor
            });
          }
        }
      });
    },
    getSystems(){
      elg()
      .get("/api/v1/systems")
      .then(res => {
        this.systems = res.data;
      });
    },
    getAutomaticPaymentReports(){
      console.info('getAutomaticPaymentReports(){')
      return elg()
      .get(`/api/v1/users/${jwt.getUserId()}/automaticpaymentreports`)
      .then( res => {
        this.automaticpaymentreports = res.data;
      })
    },
    deleteAutomaticPaymentReport(){
      elg()
      .delete(`/api/v1/users/${jwt.getUserId()}/automaticpaymentreports/${this.selected.automaticpaymentreport}`)
      .then( res => {
          this.getAutomaticPaymentReports();
          this.$refs.deleteAutomaticPaymentReportConfirm.hide();
      });
    },
    showDeleteReport(data){
      this.selected.automaticpaymentreport = data.item.AutomaticPaymentReportID;
      this.$refs.deleteAutomaticPaymentReportConfirm.show();
    },
    showAddReport(){
      this.$refs.addAutomaticPaymentReportConfirm.show();
    },

    validateBeforeSubmit(scope, submit) {
      this.$validator.validateAll(scope)
      .then( result => {
        if(result){
          submit();
        }
      })
    },
    submitNewPaymentReport(){
      var payload = {
        Distributor: this.selected.distributor,
        LogosID: this.selected.system,

        From: moment(this.selected.from).utc(),
        To: moment(this.selected.to).utc()
      }

      elg()
      .post(`/api/v1/users/${jwt.getUserId()}/paymentreports`, payload)
      .then( res => {
        this.$refs.paymentReportRequested.show();
      });
    },
    submitNewAutomaticPaymentReport() {
      var payload = {
        AutomaticPaymentReportTypeID: this.selected.automaticpaymentreporttype,
        Distributor: this.selected.distributor,
        LogosID: this.selected.system
      }

      elg()
      .post(`/api/v1/users/${jwt.getUserId()}/automaticpaymentreports`, payload)
      .then( res => {
        this.automaticpaymentreports.push(res.data);
        this.$refs.addAutomaticPaymentReportConfirm.hide();
      })
      
    },

  },
  mounted(){
    this.getAutomaticPaymentReports()
    .then( () => {
      this.getDistributors();
      this.getSystems();
    })

    this.selected.from = new moment().subtract(1, 'months').date(1).format('YYYY-MM-DD');
    this.selected.to = new moment().date(0).format('YYYY-MM-DD');
    this.selected.user = jwt.getEmail();
  }
};
</script>

<style scoped>
  .error{
    color: red;
    font-size: 12px;
  }
</style>


// WEBPACK FOOTER //
// WebApp/components/TransactionReports.vue